import React, { useCallback, useEffect, useRef, useState } from 'react';
import { View } from "react-native"
import { connect, useDispatch, useSelector } from "react-redux"
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import { useIsInViewport } from '../../../utilsv1/helpers'
import { social_createPostReaction, social_getCommentStatByPostId, social_getPodcastEpisodeById, social_getReactionsByPostIdAndPlayerId, social_getReactionStatsByPostId, social_logImpression, social_updatePost, social_updatePostReaction } from '../../../store/actionsv1/social';
import { PlayerReferralProps, PublicPlayerProps } from '../../../store/types/auth_svc';
import { ImpressionProps, PodcastEpisodeProps, PostCommentStatProps, PostProps, PostReactionProps, PostReactionStatsProps } from "../../../store/types/soc_svc"
import FormattedTextViewer from './FormattedTextViewer';
import PostCardHeader from './PostCardHeader';
import PostReactionBar from './PostReactionBar';
import MediaHolder from './MediaHolder';
import URLPreviewCard from './URLPreviewCard';
import OrderHolder from './OrderHolder';
import SharedPostHolder from './SharedPostHolder';
import { player_getBulkPlayers } from '../../../store/actionsv1/player';
import moment from 'moment';
import { getCoordinates } from '../../../utilsv1/location';
import PodcastEpisodeCard from './PodcastEpisodeCard';
import { Icon } from 'react-native-elements';
import PostArticleHolder from './PostArticleHolder';
import { V1_UPDATE_CHALLENGER } from '../../../store/actionsv1/types';
import { BELinkApi } from 'be-components';
import { util_updateShare } from '../../../store/actionsv1/utils';


type PostCardProps = {
    navigation: any,
    post: PostProps,
    view_type: 'feed' | 'detail' | 'shared'
}

const PostCard = ({ navigation, post, view_type }:PostCardProps) => {
    const [ reactions_loaded, setReactionsLoaded ] = useState(false)
    const [ post_size, setPostSize ] = useState({ width:0, height:0 });
    const dispatch = useDispatch();
    
    //Update on authentication
    const isAuthenticated:boolean = useSelector((state:any) => state.auth.isAuthenticated, (left, right) => left == right)
    
    //Update on player id change
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id )
    const player_referral:PlayerReferralProps | undefined = useSelector((state:any) => state.player.player_referral, (left, right) => left?.last_update_datetime == right?.last_update_datetime)
 
    //update when post reaction status length changes
    const post_reaction_stats: PostReactionStatsProps[] = useSelector((state:any) => state.social.post_reaction_stats.filter((prs:PostReactionStatsProps) => prs.activity_post_id == post.memo_post_id), (left, right) => left?.length == right?.length )
    
    //Update if the company tag is visible or not
    const company_id = post.memo_topics?.find(t => t.tag_type === 'company')?.company_id
    const company:PublicPlayerProps | undefined = useSelector((state:any) => state.social.stored_players.find(p => p.player_id == company_id), (left, right) => left?.player_id == right?.player_id)
    
    //Update when comment count changes
    const post_comment_stat: PostCommentStatProps = useSelector((state:any) => state.social.post_comment_stats.find((pcs:PostCommentStatProps) => pcs.activity_post_id == post.memo_post_id), (left, right) => left?.comment_count == right?.comment_count)

    //Update when post reaction length changes
    const my_post_reactions:PostReactionProps[] = useSelector((state:any) => state.social.my_post_reactions.filter((pr:PostReactionProps) => pr.activity_post_id == post.memo_post_id && pr.status === 'visible'), (left, right) => left?.length == right?.length)

    

    //Update if a podcast episode changes
    let podcast_episode:PodcastEpisodeProps | undefined = undefined
    podcast_episode = useSelector((state:any) => state.social.viewing_episodes.find(pe => pe.podcast_episode_id == post.memo_podcast_episodes[0]), (left, right) => left?.podcast_episode_id == right?.podcast_episode_id)


    //Update when enters viewport
    const ref = useRef()
    const isInViewport1 = useIsInViewport(ref)


    useEffect(() => {
        if(isInViewport1 && !reactions_loaded && view_type !== 'shared'){
            setReactionsLoaded(true)
            getReactionStatsFromServer(post.memo_post_id)
            if(!podcast_episode && post.memo_podcast_episodes?.length > 0){
                dispatch(social_getPodcastEpisodeById(post.memo_podcast_episodes[0]))
            }

        }
        if(isInViewport1){
            logImpression(post)
        }

    },[isInViewport1])

    const logImpression = async(p:PostProps) => {
        let impression:ImpressionProps = {
            impression_id:'',
            impression_start_datetime: moment(),
            impression_end_datetime:moment(),
            activity_id: p.memo_post_id??'0',
            activity_type: 'post',
            impression_type:'view',
            impression_datetime:'',
            viewer_id:player?.player_id??'0',
            player_id:p.player_id,
            location: undefined//await getCoordinates()
        }
        social_logImpression(impression)
    }

    const getReactionStatsFromServer = async(post_id:string) => {
        if(!player){ return }
        await dispatch(social_getReactionStatsByPostId(post_id, 'memo'))
        await dispatch(social_getReactionsByPostIdAndPlayerId(player.player_id, post_id, 'memo'))
        await dispatch(social_getCommentStatByPostId(post_id, 'memo'))
    }

    const handleReaction = async(reaction:string) => {
        if(!player || !isAuthenticated){ return navigation.navigate('AuthStack', { screen:'Login' }) }
        let existing_reaction = my_post_reactions.find(pr => pr.reaction === reaction)
        if(existing_reaction){ return await dispatch(social_updatePostReaction({ ...existing_reaction, status: existing_reaction.status === 'visible' ? 'hidden' : 'visible' })) }
        let pr:PostReactionProps = {
            post_reaction_id: '',
            activity_post_id: post.memo_post_id,
            post_type: 'memo',
            player_id: player.player_id,
            create_datetime: '',
            last_update_datetime: '',
            reaction,
            status: 'visible'
        }
        await dispatch(social_createPostReaction(pr))
    }
    
    const handleShareExternal = async() => {

        dispatch(util_updateShare({
            share_key: `post_${post.memo_post_id}_share`,
            visible:true,
            title: `${post.title}`,
            type_id: post.memo_post_id,
            generator:'player',
            link_type: 'user_generated_link',
            link_sub_type: 'social_post_link',
            redirect_url: `https://app.bettoredge.com/social/activity/detail/${post.memo_post_id}/memo`,
        }))
    }

    const handleHeaderAction = async(action:string) => {
        switch(action){
            case 'challenge': 
                navigation.navigate('EventStack', { screen: 'Events' })
                return dispatch({ type:V1_UPDATE_CHALLENGER, player:post.playerDetails })
            case 'view': return navigation.navigate('SocialStack', { screen: 'SocialProfile', initial:false, params: { player_id: post.player_id }})
            case 'edit': return navigation.navigate('SocialStack',  {screen: 'MemoPost', initial:false, params: { type: 'edit', post_id: post.memo_post_id }})
            case 'share': return navigation.navigate('SocialStack',  {screen: 'MemoPost', initial:false, params: { type: 'share', post_id: post.memo_post_id }})
            case 'native_share': return handleShareExternal()
            case 'delete': return await dispatch(social_updatePost({ ...post, status:'deleted' }))
            default: return
        }
    }
    let media_size = 0
    if(post.memo_images){
        media_size += post.memo_images.length
    }
    if(post.memo_videos){
        media_size += post.memo_videos.length
    }


    return (
        <View ref={ref} style={view_type==='feed' ? { ...styles.postContainer }: view_type === 'shared' ? styles.sharedContainer : styles.detailContainer}>
            {post.featured && view_type === 'feed' ?
            <View style={{ padding:10, backgroundColor:Colors.brand.electric, borderTopRightRadius:10, borderTopLeftRadius:10 }}>
                <Text size={14} color={Colors.shades.white} weight='semibold'>{post.title}</Text>
            </View>
            :<></>}
            {post.playerDetails ?
            <View nativeID='post-header' style={{ padding:15 }}>
                <PostCardHeader 
                    post_id={`P${post.memo_post_id}`} 
                    create_datetime={post.create_datetime} 
                    company={company} 
                    hide_actions={view_type==='shared'} 
                    viewer_id={player?.player_id??'0'} 
                    player={post.playerDetails} 
                    onActionPress={(action) => handleHeaderAction(action)}
                />
            </View>
            :<></>}
            {post.title !== '' ?
            <View nativeID='post-title' style={{paddingLeft:15, paddingRight:15}}>
                <Text size={14} color={Colors.brand.midnight} weight='semibold'>{post.title}</Text>
            </View>
            :<></>}
            {false ?
            <View style={{ height:post_size.height, width:post_size.width }} />
            :
            <View nativeID='post-body' style={{ marginTop:5 }} onLayout={(ev) => {
                const { width, height } = ev.nativeEvent.layout
                setPostSize({width, height})
            }}>
                {post.body != '' ?
                <View nativeID='post-text' style={{ paddingLeft:15, paddingRight:15 }}>
                    <FormattedTextViewer post_id={post.memo_post_id} formatted_body={post.formatted_body} view_type='memo' text_fallback={post.body}/>
                </View>
                :<></>}
                <View nativeID='post-media' style={{ marginTop:10 }}>
                    {post.shared_post_id && view_type !== 'shared' ?
                    <SharedPostHolder view_mode='view' navigation={navigation} post_id={post.shared_post_id}/>
                    :<></>}
                    <View style={{ flexDirection:'row', overflow:'scroll' }}>
                        {media_size > 0 && post_size.width !== 0 ?
                        <View style={{ margin:4 }}>
                            <MediaHolder width={post_size.width} view_mode='view' images={post.memo_images} videos={post.memo_videos}/>
                        </View>
                        :<></>}
                        { post_size.width > 0 && post.memo_podcast_episodes?.length > 0 && podcast_episode ?
                        <View style={{ margin:4 }}>
                            <PodcastEpisodeCard view_mode='view' width={post_size.width / 2} navigation={navigation} hide_description podcast_episode={podcast_episode}/>
                        </View>
                        :<></>}
                    </View>
                    {post.memo_orders?.length > 0 && post_size.width !== 0 ?
                    <OrderHolder view_mode='view' width={post_size.width} order_ids={post.memo_orders} />
                    :<></>}
                    {post.memo_articles && post.memo_articles.length > 0 ?
                    <PostArticleHolder 
                        article_ids={post.memo_articles}
                        width={post_size.width}
                    />
                    :<></>}
                    {post.memo_urls?.length > 0 && post_size.width !== 0 ?
                    <URLPreviewCard view_mode='view' hide_image={media_size>0 || post.memo_orders?.length >0?true:false} url_preview={post.url_metadata[0]} url={post.memo_urls[0]} width={post_size.width}/>
                    :<></>}
                    
                </View> 
            </View>}
            {view_type !== 'shared' ?
            <View nativeID='post_footer_actions' style={{ flexDirection:'row', flexWrap:'wrap', alignItems:'center', justifyContent:'space-between', padding:15 }}>
                <TouchableOpacity style={{ padding:10 }} onPress={() => handleShareExternal()}>
                    <Icon type='feather' name='share' color={Colors.brand.electric} size={20} />
                </TouchableOpacity>
                <View nativeID='post_reaction'>
                    <PostReactionBar featured={post.featured} my_post_reactions={my_post_reactions} post_reaction_stats={post_reaction_stats} onReactionSelect={(reaction) => handleReaction(reaction)}/>
                </View>
                {view_type !== 'detail' ?
                <TouchableOpacity style={{ justifyContent:'flex-end', margin:8 }} nativeID='post_comments' onPress={() => navigation.navigate('SocialStack', { screen: 'ActivityDetail', params: { post_id: post.memo_post_id, post_type: 'memo' }})}>
                    <Text size={14} color={Colors.highlights.highlight200}>{post_comment_stat?.comment_count??0} Comments</Text>
                </TouchableOpacity>
                :<></>}
            </View>
            :<></>}
           {post.featured ?
           <View style={{ position:'absolute', top: 5, right:5 }}>
            <Icon type='ionicon' name='flame-outline' size={20} color={Colors.highlights.highlight200}/>
            </View>
           :<></>}
        </View>
    )
}


const styles = {
    postContainer: { justifyContent:'center', margin:10, marginBottom:8, marginTop:8, borderRadius: 10, backgroundColor: Colors.shades.white, shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 },
    sharedContainer: { justifyContent:'center', margin:10, marginBottom:8, marginTop:8, borderRadius: 10, backgroundColor: Colors.shades.white, borderWidth:1, borderColor:Colors.brand.electric },
    detailContainer: { margin:0, borderRadius:0, borderBottomWidth:1, borderBottomColor:Colors.highlights.highlight200,  backgroundColor: Colors.shades.white, shadowColor: "rgba(0, 0, 0, 0.12)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1  },

}


export default React.memo(PostCard, (left, right) => {
    if(left.post.memo_post_id != right.post.memo_post_id){ return false }
    if(left?.view_type != right?.view_type){ return false }
    return true
})